import { Injectable } from '@angular/core';

@Injectable()
export class CustomerService {
  create(data: any): void {

  }
}
